import { ES, FR, GB, SA, type FlagComponent } from "country-flag-icons/react/3x2";
import type { Locale } from "./locale.type";

// One flag per language (a language is not a country: English = UK, Arabic = Saudi Arabia).
export const LOCALE_FLAGS: Record<Locale, FlagComponent> = {
  en: GB,
  fr: FR,
  es: ES,
  ar: SA,
};
